import { useAPI, useAsyncHandler } from '~/hooks/common';

import { API_ENDPOINT } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypeGetOutboundsParams, TypeGetOutboundsResponse } from '~/types/delivery-agency.types';

const useGetOutbounds = () => {
  const { runAsync } = useAsyncHandler();

  const getOutbounds = useAPI<TypeGetOutboundsParams, TypeGetOutboundsResponse>({
    endpoint: API_ENDPOINT.DELIVERY_AGENCY.GET_OUTBOUNDS,
    method: 'get',
  });

  const requestOutbounds = async (
    params: TypeGetOutboundsParams,
    {
      onSuccess,
      onError,
    }: {
      onSuccess?: (data: TypeGetOutboundsResponse['data']) => void;
      onError?: (error: TypeErrorResponseData['error']) => void;
    }
  ) => {
    runAsync(() => getOutbounds({ params }), {
      onSuccess: ({ data }) => onSuccess?.(data),
      onError: (error: TypeErrorResponseData['error']) => onError?.(error),
    });
  };

  return { requestOutbounds };
};

export default useGetOutbounds;
